const firebaseConfig = {
  apiKey: "AIzaSyCBFtPh5WP08XjFLTGZkr92-LAI4bafIWk",
  authDomain: "internet-service-system.firebaseapp.com",
  projectId: "internet-service-system",
  storageBucket: "internet-service-system.appspot.com",
  messagingSenderId: "1068015709570",
  appId: "1:1068015709570:web:4c1ebdb293fbb7311cb39b"
};

  export default firebaseConfig;